<script lang="ts">
	import type { Snippet } from 'svelte';
	import Logo from './Logo.svelte';

	let { children }: { children: Snippet } = $props();
</script>

<header class="border-b border-rule">
	<div class="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-6 py-3">
		<Logo href="/" />
		<div class="flex flex-wrap items-center gap-x-4 gap-y-2">
			{@render children()}
		</div>
	</div>
</header>
